module.exports = {
      id: "Calculator-usage",
      viewBox: "0 0 220 220",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Calculator-usage",
      toString: function () {
        return this.url;
      }
    }